import { useState } from 'react'
import { useFirebase } from '../../../utils/hooks/useFirebase'
import { useIsomorphicEffect } from '@codeleap/common'

export const useFirebaseUser = (timeout = 3000) => {
  const firebase = useFirebase()
  const [timedOut, setTimedOut] = useState(false)

  const [firebaseUser, setFirebaseUser] = useState(() => {
    if (!firebase) {
      return undefined
    }

    return firebase.auth().currentUser
  })

  useIsomorphicEffect(() => {
    let timeoutId = setTimeout(() => {
      setTimedOut(true)
      timeoutId = null
    }, timeout)

    if (!firebase) {
      return () => {
        if (timeoutId) clearTimeout(timeoutId)
      }
    }

    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      setFirebaseUser(user)
      if (timeoutId && !!user) {
        clearTimeout(timeoutId)
      }
    })

    return () => {
      if (timeoutId) clearTimeout(timeoutId)
      unsubscribe()
    }
  }, [!!firebase, timeout])

  if (timedOut) {
    return null
  }

  return firebaseUser
}
